<script setup lang="ts">
defineProps<{
  isOpen: boolean;
}>();
</script>

<template>
  <div class="drop" v-if="isOpen">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.drop {
  position: absolute;
  background: #fff;
  left: calc(100% + 10px);
  top: calc(50% - 12px);
  transform: translateY(-50%);
  z-index: 1001;
  box-shadow: 2px 2px 12px 0 rgba(0,0,0,.1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -28px;
    width: 30px;
    height: 36px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyOCAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4IDBWMzZMMi4yODc0NiAyMC41NzI1QzAuMzQ1NDQ4IDE5LjQwNzMgMC4zNDU0NDggMTYuNTkyNyAyLjI4NzQ2IDE1LjQyNzVMMjggMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    transition: all .3s;
    text-decoration: none;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: #000;
    height: 38px;

    &:hover {
      background-color: #f9f9f9;
    }

    &.disabled {
      opacity: .4;
      pointer-events: none;
    }
  }
}
</style>